import React, { PropsWithChildren } from 'react';

export default function AkYellowBg({ children }: PropsWithChildren<{}>) {
    return <span style={{ backgroundColor: 'rgba(250,223,97,0.51)' }}>{children}</span>;
}
